import React, { useState } from "react";
import { getImageUrl, getPlaceholderIcon } from "../../helpers/Utils";

/**
 * ProductImage component với icon placeholder khi ảnh lỗi
 * @param {string} image - URL hoặc path của ảnh
 * @param {string} alt - Alt text cho ảnh
 * @param {string} businessType - Loại ngành hàng (cafe, restaurant, fashion, retail, grocery)
 * @param {string} fnbType - Phân loại FnB của sản phẩm (food, drink)
 * @param {string} className - CSS class cho img/div
 * @param {function} onClick - Click handler
 * @param {object} style - Inline styles
 */
const ProductImage = ({
  image,
  alt,
  businessType,
  fnbType,
  className = "",
  onClick,
  style = {},
  iconSize = "50px",
  height,
}) => {
  const [imageError, setImageError] = useState(false);

  // Reset error state when the image prop changes
  React.useEffect(() => {
    setImageError(false);
  }, [image]);

  const imgSrc = getImageUrl(image);
  const hasImage = Boolean(imgSrc);

  // Lấy businessType từ localStorage nếu không được truyền vào
  const actualBusinessType =
    businessType || localStorage.getItem("businessType") || "cafe";

  // Xác định style cho placeholder
  const getPlaceholderStyle = () => {
    const baseStyle = {
      cursor: onClick ? "pointer" : "default",
      ...style,
    };

    if (className.includes("card-img-top")) {
      return {
        ...baseStyle,
        aspectRatio: "4/3",
        width: "100%",
      };
    }

    if (height) {
      return {
        ...baseStyle,
        height: height,
      };
    }

    return baseStyle;
  };

  // Hiển thị placeholder nếu lỗi hoặc không có ảnh
  if (!hasImage || imageError) {
    return (
      <div
        className={`${className} d-flex align-items-center justify-content-center product-placeholder`}
        style={getPlaceholderStyle()}
        onClick={onClick}
      >
        <i
          className={getPlaceholderIcon(actualBusinessType, fnbType)}
          style={{
            fontSize: iconSize,
            color: "#888",
          }}
        />
      </div>
    );
  }

  // Nếu là card-img-top, wrap trong div để giữ aspect ratio
  if (className.includes("card-img-top")) {
    return (
      <div
        className={`${className} product-placeholder`}
        style={{
          ...style,
          aspectRatio: "4/3",
          width: "100%",
          position: "relative",
          overflow: "hidden",
          cursor: onClick ? "pointer" : "default",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={onClick}
      >
        <img
          alt={alt}
          src={imgSrc}
          onError={() => setImageError(true)}
          loading="lazy"
          decoding="async"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // Đổi thành cover để lấp đầy khung
          }}
        />
      </div>
    );
  }

  return (
    <img
      alt={alt}
      src={imgSrc}
      onError={() => setImageError(true)}
      loading="lazy"
      decoding="async"
      className={className}
      style={style}
      onClick={onClick}
    />
  );
};

export default ProductImage;
